module.exports = __webpack_public_path__ + "img/home_snake_2.4f8f8490.jpg";